import 'intersection-observer';
import { capfirst, intcomma } from 'journalize';
import yall from 'yall-js';

mapboxgl.accessToken =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

let hoverId = null;
let con = document.getElementById('console');
let box = document.getElementById('box');
let tableHolder = document.getElementById('poptable-holder');
let table = document.getElementById('poptable');

const map = new mapboxgl.Map({
  container: 'app',
  style: `mapbox://styles/latimes/cjyyzq0zf49w11dp1yxh0ivhv${
    process.env.NODE_ENV === 'development' ? '/draft' : ''
  }`,
  center: [-118.24, 34.05],
  minZoom: 7.5,
  zoom: 11,
  scrollZoom: false,
});

// zoom nav
const nav = new mapboxgl.NavigationControl({ showCompass: false });
//geocoder
const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  countries: 'us',
  bbox: [-120.1, 32.6, -115.9, 35.4],
  mapboxgl,
});

document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

//load data source layer
map.on('load', () => {
  map.addSource('data', {
    type: 'vector',
    url: 'mapbox://latimes.4cuaqx2e',
  });

  //add layer
  map.addLayer({
    'id': 'hover-layer',
    'type': 'fill',
    'source': 'data',
    'source-layer': 'la_blocks',
    'layout': {},
    'paint': {
      'fill-color': 'black',
      'fill-outline-color': 'rgba(0,0,0,0)',
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0.5,
        0,
      ],
    },
  });

  geocoder.on('result', function(ev) {
    clearFeatureState();
    const coords = ev.result.center;
    const projected = map.project([coords[0], coords[1]]);
    const features = map.queryRenderedFeatures(projected, {
      layers: ['hover-layer'],
    });

    if (features) {
      createFeatureState(features[0].id);
      displayInfo(features[0].properties);
    }
  });
});

const clearFeatureState = function() {
  // Clear out the hover
  if (hoverId) {
    map.setFeatureState(
      {
        source: 'data',
        sourceLayer: 'la_blocks',
        id: hoverId,
      },
      { hover: false }
    );
    hoverId = null;
  }
  // Clear out the table console
  con.setAttribute('hidden', '');
};

const createFeatureState = function(id) {
  // Set the mouse cursor
  map.getCanvas().style.cursor = 'pointer';
  // Set the hover state
  hoverId = id;
  map.setFeatureState(
    {
      source: 'data',
      sourceLayer: 'la_blocks',
      id: id,
    },
    { hover: true }
  );
  //Make table console visible
  con.removeAttribute('hidden', '');
};

const get_dict = d => {
  let dict = {
    'buttigieg': d.buttigieg,
    'harris': d.harris,
    'sanders': d.sanders,
    'warren': d.warren,
    'gillibrand': d.gillibrand,
    'yang': d.yang,
    "O'Rourke": d.orourke,
    'bullock': d.bullock,
    'biden': d.biden,
    'williamson': d.williamson,
    'bennet': d.bennet,
    'booker': d.booker,
    'klobuchar': d.klobuchar,
    'gabbard': d.gabbard,
    'castro': d.castro,
    'inslee': d.inslee,
  };

  // go through the dictionary and reduce
  let rest_dict = Object.keys(dict).reduce((k, v) => {
    if (dict[v] > 0) k[v] = dict[v];
    return k;
  }, {});

  //into array and sort
  let sortable = Object.entries(rest_dict).sort((a, b) => b[1] - a[1]);
  let ordered_dict = {};
  //put it back into object
  sortable.forEach(d => {
    ordered_dict[d[0]] = d[1];
  });
  let names = Object.keys(ordered_dict);
  let values = Object.values(ordered_dict);

  return {
    dict: ordered_dict,
    names: names,
    values: values,
  };
};

const vtable = results => {
  for (var i = 0; i < results.names.length; i++) {
    let row = table.insertRow();
    let nameCell = row.insertCell();
    let moneyCell = row.insertCell();

    moneyCell.classList.add('super-text-right');
    nameCell.innerHTML = `${capfirst(results.names[i])}`;
    moneyCell.innerHTML = `${i === 0 ? '$' : ''}${intcomma(
      Math.round(results.values[i])
    )}`;
  }
};

const htable = results => {
  let row1 = table.insertRow();
  let row2 = table.insertRow();
  for (var i = 0; i < results.names.length; i++) {
    row1.insertCell().innerHTML = `${capfirst(results.names[i])}`;
    row2.insertCell().innerHTML = `$${intcomma(Math.round(results.values[i]))}`;
  }
};

const tinyTable = results => {
  let row1 = table.insertRow();
  let row2 = table.insertRow();
  let row3 = table.insertRow();
  for (var i = 0; i < 6; i++) {
    row1.insertCell().innerHTML = `${capfirst(results.names[i])}`;
    row2.insertCell().innerHTML = `$${intcomma(Math.round(results.values[i]))}`;
    row3.insertCell();
  }
  row3.cells[0].style.display = 'inline-grid';
  row3.cells[0].innerHTML =
    '<div style="white-space:nowrap;width:0px;">Other candidates also raised money in this area.</div>';
};

const displayInfo = function(d) {
  let top_candidate = d.top_candidate;

  const results = get_dict(d);

  // different table depending on orientation
  if (top_candidate == '') {
    box.style.visibility = 'visible';
    box.innerHTML = `<p>No contributions</p>`;
    tableHolder.style.visibility = 'hidden';
    con.classList.add('no-table');
  } else {
    let people = results.names.length;
    con.classList.remove('no-table');
    box.innerHTML = '';
    box.style.visibility = 'visible';
    tableHolder.style.visibility = 'visible';
    //remove old table
    while (table.hasChildNodes()) {
      table.removeChild(table.lastChild);
    }

    // create new table based on orientation
    if ((people > 5) & (window.innerWidth < window.innerHeight)) {
      tinyTable(results);
    } else {
      window.innerWidth < window.innerHeight
        ? htable(results)
        : vtable(results);
    }
  }
};

// When the mouse moves
const onMousemove = function(e) {
  // Clear out any other features
  clearFeatureState();
  // Pick apart the feature
  const feature = e.features[0];
  const id = feature.id;
  const d = feature.properties;
  // Set this feature
  createFeatureState(id);
  displayInfo(d);
};

const onMouseleave = function() {
  clearFeatureState();
};

// execute
map.addControl(new mapboxgl.FullscreenControl(), 'top-left');
map.addControl(nav, 'top-left');
map.on('mousemove', 'hover-layer', onMousemove);
map.on('mouseleave', 'hover-layer', onMouseleave);

// LEGEND stuff
let cat6 = ['#7570b3', '#66a61e', '#e6ab02', '#1b9e77', '#d95f02', '#ababab'];
let cat6names = ['Biden', 'Buttigieg', 'Harris', 'Sanders', 'Warren', 'Other'];
let i = 0;
let ii = 0;

let fillblock = el => {
  el.style.backgroundColor = cat6[i];
  i++;
};
let tag = el => {
  el.firstElementChild.innerHTML = cat6names[ii];
  ii++;
};

let l = document.getElementById('legend-wrapper');

let block = l.querySelectorAll('div');

block.forEach(function(el) {
  fillblock(el);
  tag(el);
});

$('.table_toggle_c').click(function() {
  $('tr.candidate_row').toggleClass('display_block');
  $('#candidate_more .btn_text').toggleClass('display_none');
});

$('.table_toggle_i').click(function() {
  $('.ie_collapse').toggleClass('display_none');
  $('#ie_more .btn_text').toggleClass('display_none');
});

document.addEventListener('DOMContentLoaded', yall);
